import React, { useMemo } from "react";
import { countryToAlpha2 } from "country-to-iso";
import ReactCountriesFlags from "react-countries-flags";
import { Flex, Text } from "@jsq/ds/core";

export const CountryFlagView: React.FC<{ countryName?: string }> = ({ countryName }) => {
  const countryCode = useMemo(
    () => (typeof countryName === "string" ? countryToAlpha2(countryName) : null),
    [countryName],
  );
  return (
    <Flex alignItems="center" gap={4}>
      {countryCode && (
        <Flex>
          <ReactCountriesFlags
            data-testid="country-flag"
            isoCode={countryCode}
            alt={`${countryCode} flag`}
          />
        </Flex>
      )}
      <Text data-testid="country-name" data-cy="country-name">
        {countryName ?? "N/A"}
      </Text>
    </Flex>
  );
};
